import type { NoteDetail } from "@/core/types";

import { CosignRejectedAlert } from "./CosignRejectedAlert";
import { NoteStatusRow } from "./NoteStatusRow";

type RejectedNoteStatusProps = {
  note: NoteDetail;
};

export function RejectedNoteStatus({ note }: RejectedNoteStatusProps) {
  return (
    <NoteStatusRow note={note}>
      <CosignRejectedAlert noteId={note.id} />
    </NoteStatusRow>
  );
}
